// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactsPage_container__m5yBE","container_body":"ContactsPage_container_body__HvEqD"};